import { getSupabaseUrl } from '../supabase/client';

/**
 * 规范化图片 URL（兼容 /sb-api/、/storage/、完整 URL）
 */
function processImageUrl(src: string): string {
  if (!src) return '';
  if (src.startsWith('http://') || src.startsWith('https://')) return src;
  if (src.startsWith('/storage/')) return `${getSupabaseUrl()}${src}`;
  if (src.startsWith('/sb-api/')) return src;
  return src;
}

/**
 * 题目 HTML 渲染预处理（教师批改页专用）
 *
 * 严格所见即所得：只做实体反转义 + 图片 URL 规范化，不注入任何样式。
 * - 不强制 display:inline-block / vertical-align / margin
 * - 不强制 <p> 加 display:flex / flex-wrap
 * 完全按数据库原始 HTML 渲染，与编辑器 1:1 复刻。
 *
 * @param html - 原始 HTML
 * @param _imageWidths - 已废弃，保留参数仅为接口兼容
 * @returns 处理后的 HTML
 */
export function processQuestionHtml(html: string, _imageWidths?: number[]): string {
  if (!html) return html;

  // 阶段 1：HTML 实体反转义（数据可能被转义存储）
  let processed = html
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#10;/g, '\n')
    .replace(/&amp;/g, '&');

  // 阶段 2：图片 URL 规范化（双引号 + 单引号两种情况）
  processed = processed.replace(/<img([^>]+)src="([^"]+)"([^>]*)>/g, (match, before, src, after) => {
    const fullSrc = processImageUrl(src);
    return `<img${before}src="${fullSrc}"${after}>`;
  });

  processed = processed.replace(/<img([^>]+)src='([^']+)'([^>]*)>/g, (match, before, src, after) => {
    const fullSrc = processImageUrl(src);
    return `<img${before}src="${fullSrc}"${after}>`;
  });

  // 严格所见即所得：不再注入任何 display/margin/flex 样式
  return processed;
}

export function getImageUrl(img: unknown): string {
  if (typeof img !== 'string' || !img) return '';
  if (img.startsWith('/sb-api/')) return img;
  if (img.startsWith('/storage/')) return `${getSupabaseUrl()}${img}`;
  return img;
}
